import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';
import { MovimientoCajaService } from '@p-p-portafolio/services/movimientoCaja.service';
import { SwalService } from '@shared/utils/swal.service';
import { MovimientoCajaFormComponent } from './movimientoCaja-form/movimientoCaja-form.component';
import Swal from 'sweetalert2';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-movimientoCaja',
  templateUrl: './movimientoCaja.component.html',
  styleUrls: ['./movimientoCaja.component.css']
})
export class MovimientoCajaComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayedColumns: Column[] = [
    { field: 'iOrigen', header: 'Código' },
    { field: 'sDescripcion', header: 'Descripción' },
    { field: 'moneda', header: 'Moneda' },
    { field: 'iAutorizacion', header: 'Autorización' },
    { field: 'actions', header: 'Acciones' }
  ];

  private readonly _width: string = '1000px';
  public loading: boolean = true;
  public dataSource: any[] = [];

  constructor(
    public dialog: MatDialog,
    private movimientoCajaService: MovimientoCajaService,
    private swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    this.movimientoCajaService.read().subscribe({
      next: (response) => {
        if (response.data) {
          this.dataSource = response.data;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar movimientos de caja:', err);
        this.swalService.error('Error al cargar los datos');
        this.loading = false;
      }
    });
  }

  openCreate() {
    const dialogRef = this.dialog.open(MovimientoCajaFormComponent, {
      width: this._width,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.read();
      }
    });
  }

  openUpdate(model: any) {
    const dialogRef = this.dialog.open(MovimientoCajaFormComponent, {
      width: this._width,
      data: model,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.read();
      }
    });
  }

  delete(model: any) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el movimiento ${model.iOrigen}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.movimientoCajaService.delete(model).subscribe({
          next: (response) => {
            if (response.exito === 1) {
              this.swalService.success('Eliminado correctamente');
              this.read();
            } else {
              this.swalService.error('No se pudo eliminar');
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this.swalService.error('Error al eliminar');
            this.loading = false;
          }
        });
      }
    });
  }
}
